import { createSlice } from '@reduxjs/toolkit';

interface FacilityState {
  clearSearch: boolean;
}

const initialState: FacilityState = {
  clearSearch: false,
};

const facilitySlice = createSlice({
  name: 'facility',
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.clearSearch = true;
    },
    resetClearSearch: (state) => {
      state.clearSearch = false;
    },
  },
});

export const facilityActions = facilitySlice.actions;

export default facilitySlice.reducer;
